import { Routes, Route, Navigate } from 'react-router-dom';
import Onboarding from '../pages/Onboarding/Onboarding';

/**
 * Routes for authenticated, paid-up users who still need to complete the
 * post-payment lead-qualification form. Mounted by `App.tsx` between the
 * billing wall and `AuthenticatedRoutes`. Every other path redirects to
 * /onboarding so the gate can't be bypassed by deep-linking.
 */
const OnboardingRoutes = () => {
  return (
    <Routes>
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="*" element={<Navigate to="/onboarding" replace />} />
    </Routes>
  );
};

export default OnboardingRoutes;
